import React from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation
} from "react-router-dom";

const Navlinks = ({mobile}) => {
        const location = useLocation();
    
    return (
        <>
            <li  data-bs-dismiss={mobile&&"offcanvas"} className="nav-item w-100 py-2">
                <Link
               
                    to="/user-dashboard"
                    className={`customlinks nav-link ${location.pathname === "/user-dashboard" ? "active" : ""}`}
                >
                    <i className="fs-4 bi-house"></i>{" "}
                    <span className="ms-1">Home</span>
                </Link>
            </li>

            <li  data-bs-dismiss={mobile&&"offcanvas"} className="nav-item w-100 py-2">
                <Link
              
                    to="/user-dashboard/staking"
                    className={`customlinks nav-link ${location.pathname.startsWith("/user-dashboard/staking") ? "active" : ""}`}
                >
                    <i className="fs-4 bi-house"></i>{" "}
                    <span className="ms-1">Staking</span>
                </Link>
            </li>
            
            <li  data-bs-dismiss={mobile&&"offcanvas"} className="nav-item w-100 py-2">
                <Link
              
                    to="/user-dashboard/transfer"
                    className={`customlinks nav-link ${location.pathname.startsWith("/user-dashboard/transfer") ? "active" : ""}`}
                >
                    <i className="fs-4 bi-house"></i>{" "}
                    <span className="ms-1">Transfer</span>
                </Link>
            </li>
            
            <li  data-bs-dismiss={mobile&&"offcanvas"} className="nav-item w-100 py-2">
                <Link
              
                    to="/user-dashboard/referrals"
                    className={`customlinks nav-link ${location.pathname.startsWith("/user-dashboard/referrals") ? "active" : ""}`}
                >
                    <i className="fs-4 bi-house"></i>{" "}
                    <span className="ms-1">Referrals</span>
                </Link>
            </li>
            <li  data-bs-dismiss={mobile&&"offcanvas"} className="nav-item w-100 py-2">
                <Link
              
                    to="/user-dashboard/withdraw"
                    className={`customlinks nav-link ${location.pathname.startsWith("/user-dashboard/withdraw") ? "active" : ""}`}
                >
                    <i className="fs-4 bi-house"></i>{" "}
                    <span className="ms-1">Withdraw</span>
                </Link>
            </li>
     
        </>
    )
}

export default Navlinks